import { Button } from '@/components/ui/button';

interface Props {
  count: number;
  onClear: () => void;
  onApply: () => void;
}

/**
 * Pinned header for multi-select filter popovers: quiet local Clear on the
 * left (resets only this field, keeps the popover open), primary Apply on the right.
 */
export function FilterPopoverHeader({ count, onClear, onApply }: Props) {
  return (
    <div className="sticky top-0 z-10 flex items-center justify-between gap-2 bg-popover border-b p-2">
      <Button
        variant="quiet"
        size="sm"
        className="h-8 px-2 text-xs"
        onClick={onClear}
        disabled={count === 0}
      >
        Clear
      </Button>
      <Button size="sm" className="h-8" onClick={onApply}>
        Apply{count > 0 ? ` (${count})` : ''}
      </Button>
    </div>
  );
}
